import { FileOutlined, WifiOutlined } from '@ant-design/icons'

export enum StatusEnum {
  online = 'online',
  released = 'released',
  draft = 'draft'
}

export const StatusValueEnum = {
  draft: { text: 'Draft', status: 'Default' },
  online: { text: 'Active', color: '#25D1F7' },
  released: { text: 'Testing', color: '#F2995F' },
  offline: { text: 'Draft', status: 'Default' }
}

export const StatusList = [
  {
    status: StatusEnum.online,
    tagColor: 'success',
    pointColor: '#0ABB56',
    showStatus: 'Active'
  },
  {
    status: StatusEnum.released,
    tagColor: 'orange',
    pointColor: '#FF8800',
    showStatus: 'Testing'
  },
  {
    status: StatusEnum.draft,
    tagColor: '',
    pointColor: '#8B8E9A',
    background: '#F3F4F5',
    showStatus: 'Draft'
  }
]
